import { BASE_URL } from "../../../core/apiClient";
import { format, subYears } from 'date-fns';
import { Formik } from 'formik';
import { UserRole } from 'legoland-sdk/dist/experimental';
import { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Box, Button, FormGroup, Modal, ModalActions, ModalContent, ModalHeader, ModalLayout, RadioGroup, Text, Tooltip, tombac } from 'tombac';
import { createReportsLinkFromContract } from "../../contractsApi";
import { DateRangeForm } from "./DateRangeForm";
import { ProductsForm } from "./ProductsForm";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const parseDateForQuery = date => {
  return format(date, 'yyyy-MM-dd');
};
export const ReportError = styled(Text).withConfig({
  displayName: "ContractReportModal__ReportError"
})(["", " margin-top:1sp;"], tombac.text({
  color: tombac.color('danger', 500)
}));
const ContractReportModalForm = styled(Modal).withConfig({
  displayName: "ContractReportModal__ContractReportModalForm"
})(["overflow:visible;background:none;.TombacModalWindow{overflow:visible;}"]);
const reportsProducts = ['od', 'ctm', 'ja', 'ts', 'aa'];
const initialValuesFromContract = contract => {
  const today = new Date();
  const startDateFromContract = new Date(contract.startDate);
  const endDateFromContract = new Date(contract.endDate);
  const endDate = endDateFromContract < today ? endDateFromContract : today;
  const startDate = startDateFromContract > subYears(endDate, 1) ? startDateFromContract : subYears(endDate, 1);
  return {
    productsToSend: [],
    startDate,
    endDate,
    reportType: reportTypeOptions[0]
  };
};
const reportTypeOptions = [{
  label: 'Usage',
  value: 'Usage'
}, {
  label: 'Finance',
  value: 'Finance'
}];
export const ContractReportModal = _ref => {
  let {
    isModalOpen,
    closeModal,
    contract,
    role
  } = _ref;
  const products = contract.products.filter(product => reportsProducts.includes(product.id));
  const [rangeValidStatus, setRangeValidStatus] = useState({
    valid: true
  });
  const [productValidStatus, setProductValidStatus] = useState({
    valid: true
  });
  const canChooseReportType = role === UserRole.Admin || role === UserRole.Support;
  const validRangeStatusChange = useCallback(validation => {
    setRangeValidStatus(validation);
  }, [setRangeValidStatus]);
  const validProductStatusChange = useCallback(validation => {
    setProductValidStatus(validation);
  }, [setProductValidStatus]);
  const initialValues = useMemo(() => initialValuesFromContract(contract), [contract]);
  return /*#__PURE__*/_jsx(ContractReportModalForm, {
    isOpen: isModalOpen,
    onRequestClose: closeModal,
    "data-sentry-element": "ContractReportModalForm",
    "data-sentry-component": "ContractReportModal",
    "data-sentry-source-file": "ContractReportModal.tsx",
    children: /*#__PURE__*/_jsx(Formik, {
      initialValues: initialValues,
      onSubmit: () => null,
      "data-sentry-element": "Formik",
      "data-sentry-source-file": "ContractReportModal.tsx",
      "data-sentry-element": "Formik",
      children: _ref2 => {
        let {
          values,
          setFieldValue
        } = _ref2;
        return /*#__PURE__*/_jsxs(ModalLayout, {
          $ml: "3sp",
          $mr: "3sp",
          children: [/*#__PURE__*/_jsxs(ModalHeader, {
            $display: "flex",
            $justifyContent: "left",
            $mt: "4sp",
            $mb: "3sp",
            children: ["Generate ", canChooseReportType ? 'report' : 'usage report']
          }), /*#__PURE__*/_jsxs(ModalContent, {
            $mt: "0px",
            children: [canChooseReportType && /*#__PURE__*/_jsx(Box, {
              $display: "flex",
              $mb: "4sp",
              children: /*#__PURE__*/_jsx(FormGroup, {
                label: "Type",
                $flex: "1",
                children: /*#__PURE__*/_jsx(RadioGroup, {
                  onChange: reportType => setFieldValue('reportType', reportType),
                  options: reportTypeOptions,
                  variant: "horizontal",
                  value: values.reportType
                })
              })
            }), /*#__PURE__*/_jsx(DateRangeForm, {
              setRangeValidStatus: validRangeStatusChange
            }), rangeValidStatus.valid === false && /*#__PURE__*/_jsx(ReportError, {
              children: rangeValidStatus.reason
            }), /*#__PURE__*/_jsx(ProductsForm, {
              products: products,
              setProductValidStatus: validProductStatusChange
            }), /*#__PURE__*/_jsxs(ModalActions, {
              $m: "0px",
              $mt: "5sp",
              $mb: "3sp",
              children: [/*#__PURE__*/_jsx(Button, {
                variant: "flat",
                onClick: closeModal,
                $mr: "3sp",
                children: "Cancel"
              }), /*#__PURE__*/_jsx(Tooltip, {
                content: productValidStatus.valid === false ? productValidStatus.reason : undefined,
                placement: "top",
                children: _ref3 => {
                  let {
                    ref,
                    open,
                    close
                  } = _ref3;
                  return /*#__PURE__*/_jsx(Button, {
                    as: "a",
                    href: BASE_URL + createReportsLinkFromContract(contract.id, parseDateForQuery(values.startDate), parseDateForQuery(values.endDate), values.productsToSend, values.reportType.value.toUpperCase()),
                    disabled: !rangeValidStatus.valid || !productValidStatus.valid,
                    onClick: closeModal,
                    variant: "primary",
                    ref: ref,
                    onMouseOver: !productValidStatus.valid ? open : undefined,
                    onMouseLeave: close,
                    children: "Generate report (.xls)"
                  });
                }
              })]
            })]
          })]
        });
      }
    })
  });
};